import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DiscountType as DiscountTypeV1 } from '@wix/auto_sdk_ecom_checkout';
import { DiscountScope as DiscountScopeV2, DiscountSourceType } from '@wix/auto_sdk_ecom_cart-v-2';
import { PriceModel } from './Price.model';
export let DiscountScope = /*#__PURE__*/function (DiscountScope) {
  DiscountScope["DELIVERY"] = "DELIVERY";
  DiscountScope["LINE_ITEM"] = "LINE_ITEM";
  DiscountScope["CART_SUBTOTAL"] = "CART_SUBTOTAL";
  return DiscountScope;
}({});
const discountTypeV1ToDiscountScope = {
  [DiscountTypeV1.SPECIFIC_ITEMS]: DiscountScope.LINE_ITEM,
  [DiscountTypeV1.SHIPPING]: DiscountScope.DELIVERY,
  [DiscountTypeV1.GLOBAL]: DiscountScope.CART_SUBTOTAL
};
const discountScopeV2ToDiscountScope = {
  [DiscountScopeV2.LINE_ITEM]: DiscountScope.LINE_ITEM,
  [DiscountScopeV2.DELIVERY]: DiscountScope.DELIVERY,
  [DiscountScopeV2.CART_SUBTOTAL]: DiscountScope.CART_SUBTOTAL,
  [DiscountScopeV2.UNKNOWN_DISCOUNT_SCOPE]: undefined
};
export class DiscountBenefitModel {
  constructor(params) {
    _defineProperty(this, "lineItemIds", void 0);
    _defineProperty(this, "amountOff", void 0);
    _defineProperty(this, "scope", void 0);
    _defineProperty(this, "isAutomaticDiscount", void 0);
    this.lineItemIds = params.lineItemIds;
    this.amountOff = params.amountOff;
    this.scope = params.scope;
    this.isAutomaticDiscount = params.isAutomaticDiscount;
  }
  static fromV1(discount, modelContext) {
    var _discount$discountRul;
    return new DiscountBenefitModel({
      lineItemIds: discount.lineItemIds,
      amountOff: PriceModel.fromV1((_discount$discountRul = discount.discountRule) == null ? void 0 : _discount$discountRul.amount, modelContext),
      isAutomaticDiscount: !!discount.discountRule,
      scope: discountTypeV1ToDiscountScope[discount.discountType]
    });
  }
  static fromV2(discount, benefit, modelContext) {
    var _discount$source;
    return new DiscountBenefitModel({
      lineItemIds: benefit.lineItemId ? [benefit.lineItemId] : /* istanbul ignore next */undefined,
      amountOff: PriceModel.fromV2(benefit.amountOff, modelContext),
      isAutomaticDiscount: ((_discount$source = discount.source) == null ? void 0 : _discount$source.sourceType) === DiscountSourceType.AUTOMATIC_RULE,
      scope: discountScopeV2ToDiscountScope[discount.scope]
    });
  }
}
//# sourceMappingURL=DiscountBenefit.model.js.map